export default "__VITE_ASSET__Dz_uIFL5__"